export default {
  allergensData: (state) => {
    return { ...state.allergens }
  }
}
